export default __webpack_public_path__ + "static/raoufDridi-44812da63547956c18becdf8f31665da.jpg";